import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import FluidImage from 'src/utils/FluidImage'
import Heading from 'src/components/Heading'
import Label from 'src/components/Label'
import { Button } from 'src/components/ui/button'
import Wave from 'src/utils/Wave'
import GetAny from 'src/utils/GetAny'
import { Link } from "gatsby"
import resolveLink from 'src/utils/resolveLink'
import ArrowButton from "src/components/ArrowButton"
import InspectCharacter from "src/images/inspect_character.svg"

const ThreeColumnCardsItem = (props) => {
    let blok = props.blok.blok
    props = props.props
    const index = props.index+1
    return (
        <Link to={resolveLink(props.full_slug)} className={`group flex  flex-col h-full px-6 border-lightblue-600 `}>
            <FluidImage image={props.content.featured_image} className="rounded-2xl bg-white border-2 shadow-xl  mb-3 group-hover:opacity-75 group-hover:-translate-y-2 duration-300"/>
            <Label  className={`${blok?.Gradient?'text-white':''} text-sm font-semibold pb-1 group-hover:opacity-70 duration-300`}>{props.field_component.replace(/-/g, ' ').replace(/_/g, ' ')}</Label>
            <p size="h3" className={` font-display pb-7 text-2xl font-semibold  text-darkblue group-hover:opacity-70 duration-300 `}>{props.name}</p>
            {!blok?.hideButton?<Button
                variant="secondary_blue"
                to={blok?.button_target?.cached_url}
                className='bg-[#002432] !rounded-full hover before:content-[attr(before)] mt-1 max-w-[fit-content]'
                before={blok?.button_text}
            >
                {blok?.Button_title || 'View something'}
            </Button>:<></>}
        </Link>
    )
}

const ThreeColumnCards = ({ blok }) => {
    const topWave = (['both', 'top'].includes(blok.wave_position) && blok.lightblue_background) ? true : false
    const bottomWave = (['both', 'bottom'].includes(blok.wave_position) && blok.lightblue_background) ? true : false
    const bottomPadding = ((blok.wave_position === 'top' || !blok.wave_position) && blok.lightblue_background) ? true : false
    const topPadding = ((blok.wave_position === 'bottom' || !blok.wave_position) && blok.lightblue_background) ? true : false
    // If no items are selected then grab the lastest 3 use cases
    const items = blok.items.length < 1 ? GetAny(blok.items, 'use_cases', 3) : GetAny(blok.items)
    return (
        <SbEditable content={blok}>
            <>
                {(blok.lightblue_background && !blok.disable_character) && 
                    <div className="max-w-7xl mx-auto px-6">
                        <InspectCharacter className={`-mb-48 ml-12 md:w-auto w-[130px]`}/>
                    </div>
                }
                {topWave && <Wave className="" flip scale/>}
                <div className={`relative ${blok?.Gradient && 'pt-[100px] md:pt-[160px]'} ${blok.lightblue_background ? '' : 'bg-white'}`}
              style={{
                backgroundImage: blok?.Gradient ? "url('/cloud-gradient.svg')" : undefined,
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
              }}>
                    <div 
                        className={` 
                            md:max-w-[700px] xl:max-w-[1004px] mx-auto 
                            ${blok.lightblue_background ? 'py-12' : 'md:my-[100px] my-12'}
                            ${blok?.Gradient && '!py-0 !mb-0'}
                            ${bottomPadding && 'md:pb-24'}
                            ${topPadding && 'md:pt-24'}
                        `}
                    >
                        <div className={`max-w-7xl mx-auto px-6  gap-4`}>
                       {blok?.Img?.filename? <div className="flex justify-center md:justify-end">
                            <img
                                src={blok?.Img?.filename}
                                alt="Cloud Illustration"
                                className="w-full max-w-sm z-[2]"
                            />
                        </div>:<></>}

                        <p className={`${blok.Gradient?'text-white':''} text-sm text-[#002432] font-semibold uppercase pb-4`}>{blok?.Lable}</p>

                            <Heading size="h2" className={`text-3xl md:text-5xl pb-12 font-display font-semibold tracking-[-0.05em] text-darkblue`}>
                                <RichText>{blok.title}</RichText>
                            </Heading>
                            <Button
                                to={blok.button_target?.cached_url}
                                before={blok.button_text}
                                variant="secondary_blue"
                            >
                                {blok.button_text}
                            </Button>
                        </div>
                        <div className={`max-w-7xl ${blok.Gradient?'pb-28':''} mx-auto grid md:grid-cols-3 gap-y-10 mt-12`}>
                            {items.map((item, index) => (
                                <ThreeColumnCardsItem props={{...item, index}} key={item.uuid} blok={{blok}}/>
                            ))}
                        </div>
                    </div>
                </div>
                {bottomWave && <Wave className="fill-lightblue" scale/>}
            </>
        </SbEditable>
    )
}

export default ThreeColumnCards